import { formatMinutes, pn, Skeleton } from "@compass/core";
import { HomeServiceDashboardRow } from "generated/openApi";

import { DevExpressReport } from "components";
import { Column } from "devextreme-react/data-grid";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";

export const ServiceTable = (props: { rows: HomeServiceDashboardRow[] | undefined; loading: boolean }) => {
  const appTenantName = useSelector((state: RootState) => state.app.tenantName);

  return props.loading ? (
    <Skeleton variant="rounded" height={500} />
  ) : (
    <DevExpressReport
      dataSource={props.rows}
      fullPageSize
      showColumnChooser={false}
      exportFormats={["pdf", "excel", "csv"]}
      onExporting={() => {
        return {
          header: "Services",
          filename: "Services",
          tenantName: appTenantName,
        };
      }}
    >
      <Column dataField={pn<HomeServiceDashboardRow>("serviceType")} caption="Category" />
      <Column dataField={pn<HomeServiceDashboardRow>("totalStudents")} />
      <Column
        dataField={pn<HomeServiceDashboardRow>("totalDurationInMinutes")}
        caption="Total Duration"
        cellRender={(data) => formatMinutes(Number(data.text))}
      />
    </DevExpressReport>
  );
};
